<template>
  <div style="display:flex;justify-content:center;align-items: center;flex-direction:column;background-color:#F1F3F4;height:100%;">
    <v-img :src="require('@/assets/backg.png')" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%;" />
    <v-card
      width="420"
      height="450"
      outlined
    >
      <v-card-text class="text-center px-12 py-16">
        <validation-observer
          ref="observer"
        >
          <v-form
            ref="form"
            @submit.prevent="signIn"
          >
            <v-list-item style="display:flex;flex-direction:column;">
              <v-list-item-avatar
                style="margin:0px 10px -5px 0px"
                tile
              >
                <v-img :src="require('@/assets/favicon.svg')" />
              </v-list-item-avatar>
              <v-list-item-content style="margin-bottom:-30px;margin-top:10px;">
                <v-img :src="require('@/assets/accumap_text.svg')" width="190px"/>
                <!-- <span style="font-size:43px;font-weight:500;color:black">AccuMAP</span> -->
              </v-list-item-content>
            </v-list-item>
            <validation-provider
              v-slot="{ errors }"
              name="아이디"
            >
              <v-text-field
                ref="id"
                v-model="id"
                style="margin-bottom:-20px;"
                label="ID"
                required
                :rules="[rules.required]"
                :error-messages="errors"
              />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="비밀번호"
              type="password"
            >
              <v-text-field
                ref="pw"
                v-model="password"
                label="Password"
                type="password"
                required
                :rules="[rules.required]"
                :error-messages="errors"
              />
            </validation-provider>
            <v-row>
              <v-col cols="6">
                <v-btn
                  type="submit"
                  block
                  large
                  dark
                  color="#1565C0"
                >
                  로그인
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  large
                  outlined
                  color="#1565C0"
                  @click="$router.push({ name: 'SignUpAgreement' })"
                >
                  회원가입
                </v-btn>
              </v-col>
            </v-row>
            <div style="font-size: 0.7rem;margin-top:10px;line-height:140%;font-weight:500">
              This system is available to authorized users only.<br>
              <a href="mailto:it@accugenelab.com">문의메일: it@accugenelab.com</a><br>
              <a href="https://accugenelab.com/">홈페이지: https://accugenelab.com/</a><br>
            </div>
          </v-form>
        </validation-observer>
        <v-snackbar
          v-model="snackbar"
        >
          {{ msg }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
    <!-- <div style="width: 420px; font-size: 0.8rem; padding: 10px 10px; color: white; z-index: 3; display: inline-block; text-align: center;">
      This system is available to authorized users only.<br>
      Don't you have an account? Contact us.<br>
      <a href="mailto:accugene@accugenelab.com">accugene@accugenelab.com</a><br>
      <a href="https://accugenelab.com/">https://accugenelab.com/</a><br>
    </div> -->
  </div>
</template>
<script>
import crypto from 'crypto-js'
import Inko from 'inko'
import { secretKey } from '@/config/config'
import io from 'socket.io-client';
import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'SignIn',
  data: () => ({
    rules: {
      required: value => !!value || "This field cannot be empty",
    },
    snackbar : false,
    id: null,
    password: null,
    msg:'',
  }),
  created() {
    if (localStorage.accessToken) {
      this.msg = 'Your login has expired.'
      this.snackbar = true;
    }
  },
  mounted() {
    sessionStorage.removeItem('socketId');
    sessionStorage.removeItem('userId');
    this.$refs.id.focus();
  },
  methods: {
    async updateSocket(token) {
      // if (this.$socket) {
      //   this.$socket.disconnect();
      // }
      if (!Vue.prototype.$socket) {        
        let base64Url = token.split(".")[1];
        let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        let jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function(c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        let user = JSON.parse(jsonPayload);

        let userId = sessionStorage.getItem('userId');
        if (!userId) {
          userId = user.id;
          sessionStorage.setItem('userId', userId);
        }

        const socketId = uuidv4();

        Vue.prototype.$socket = io(this.$apiHost, {
          auth: {
            token: localStorage.accessToken
          },
          query: {
            userId: userId,
            socketId: socketId
          }
        });
        Vue.prototype.$socket.on('connect_error', (error) => {
          console.log(`socket error: ${error}`);
        });
        Vue.prototype.$socket.on('connect_success', (msg) => {
          console.log(`${msg}`);
        });
      }

      async function insertAuthData() {
        return new Promise((resolve) => {
          Vue.prototype.$socket.io.opts.query = { 
            auth: {
              token: localStorage.accessToken 
            }
          };
          resolve(); // Promise를 사용하여 함수 완료를 알림
        });
      }

      // await insertAuthData();
      await this.$socket.connect();

      return;
    },
    createSocket(token) {
      return io(this.$apiHost, {
        auth: {
          token: token
        }
      });
    },
    signIn () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          let inko = new Inko();
          const userId = this.id;
          let password = inko.ko2en(this.password);
          password = crypto.AES.encrypt(password, secretKey).toString();
          this.$store.dispatch('SIGNIN', { userId, password })
          .then(() => {
            this.updateSocket(localStorage.accessToken);
            // this.$socket.io.opts.query = { 
            //   auth: {
            //     token: localStorage.accessToken 
            //   }
            // };
            this.$socket.on('noticeToast', (msg) => {
              this.$toast.info(`${msg.message}`, {
                position: "top-center",
                timeout: false,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            });

            // 사용자 레벨에 따라 다른 페이지로 이동
            const token = localStorage.accessToken;
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
              atob(base64).split("").map(function(c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              }).join("")
            );
            const userData = JSON.parse(jsonPayload);
            
            // Level 4 사용자는 Virus 페이지로 이동
            if (userData.level === 4) {
              this.$router.replace('/virus');
            } else {
              this.$router.replace('/dashboard');
            }
          })
          .catch(({ message }) => {
            this.snackbar = true;
            this.msg = 'Please check your username or password.';
          })
        }
      })
    },
    // redirect() {
    //     const { search } = window.location
    //     const tokens = search.replace(/^\?/, '').split('&')
    //     const { returnPath } = tokens.reduce((qs, tkn) => {
    //         const pair = tkn.split('=')
    //         qs[pair[0]] = decodeURIComponent(pair[1])
    //         return qs;
    //     }, {})
    //     // 리다이렉트 처리
    //     if (returnPath == undefined) this.$router.push('/dashboard');
    //     this.$router.go('/dashboard');
    // }
  }
}
</script>

<style scoped>
a {
  color: #1E88E5; /* 텍스트 안쪽 색상 */
  text-decoration: none;
  text-stroke: 1px #1E88E5;
  background-color: rgba(255, 255, 255, 0.02); /* Transparent background */
  padding: 3px 6px; /* Add some padding for better visibility */
}

.v-btn {
  font-size: 14px; /* 버튼 글꼴 크기 */
  border-radius: 8px; /* 버튼 모서리 둥글게 */
}
</style>